import { Product } from 'src/types';
import { ClientMarket } from '@prisjakt/web-app-config/types/client-market';
import { AggregateOffer } from 'schema-dts';
import { getRoundedCurrency } from './utils';

export function aggregateOffer(
  product: Product,
  market: ClientMarket
): AggregateOffer {
  const prices: number[] = product?.prices?.nodes
    ? (product.prices.nodes
        .map(price => price?.price?.exclShipping)
        .filter(price => price !== undefined && price !== null) as number[])
    : [];

  return {
    '@type': 'AggregateOffer',
    url: market.domain + product.pathName,
    lowPrice: getRoundedCurrency(Math.min(...prices), market),
    highPrice: getRoundedCurrency(Math.max(...prices), market),
    offerCount: prices.length,
    priceCurrency: market.currency,
  };
}
